<span class="split-button">
  <capra-icon
    class="split-left"
    capraTooltip
    tooltipContent="Add New Cell Below (B)"
    [tooltipPlacement]="toolTipPlacement"
    [tooltipSize]="tooltipSize"
    icon="illo-icon-control-new-cell"
    (click)="insertBelow()"
  ></capra-icon>

  <span
    (click)="isNewCellDialogOpen = !isNewCellDialogOpen"
    type="button"
    cdkOverlayOrigin
    #newCellTrigger="cdkOverlayOrigin"
    class="split-right"
    [class.--is-open]="isNewCellDialogOpen"
    ><capra-icon icon="icon-caret-down"></capra-icon>
  </span>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="newCellTrigger"
    [cdkConnectedOverlayOpen]="isNewCellDialogOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="isNewCellDialogOpen = !isNewCellDialogOpen"
  >
    <ul class="overlay">
      <li (click)="insertAbove()">New Cell Above (A)</li>
      <li (click)="insertBelow()">New Cell Below (B)</li>
    </ul>
  </ng-template>
</span>
